<script setup>
import Button from "primevue/button";
import { usePage } from "@inertiajs/vue3";
import { computed } from "vue";

const pageLocale = computed(() => usePage().props.locale ?? 'cs')

function fmtDate(dateStr, options) {
    return Intl.DateTimeFormat(pageLocale.value, options).format(Date.parse(dateStr))
}
</script>

<template>
    <div v-if="$page.props.user.subscription" class="p-4 space-y-4 h-full">
        <section class="space-y-4 bg-blue-500 dark:bg-blue-700 p-2 -ml-4 pl-5 rounded-r-xl shadow-md max-w-60">
            <div class="text-white">
                <span class="text-white/80">{{ $t('settings.sub_active_since') }} </span>
                <span class="font-medium">{{ fmtDate($page.props.user.subscription.start_date, { month: 'long', year: 'numeric' }) }}</span>
            </div>
        </section>

        <section class="flex items-center justify-between border bg-white dark:bg-neutral-800 dark:border-neutral-700 p-6 rounded-lg shadow">
            <div class="flex items-center">
                <img
                    v-if="false"
                    :src="`${$page.props.olympus.files_url}/${$page.props.user.subscription.edition_image}`"
                    width="80"
                    :alt="$page.props.user.plan.name"
                    class="dark:bg-gray-200 dark:p-2"
                />
                <div>
                    <h2 class="text-xl font-bold text-gray-800 dark:!text-white">{{ $page.props.user.subscription.plan_name }}</h2>
                    <p class="text-sm text-gray-500 dark:!text-gray-200 mt-2" v-html="$page.props.user.subscription.edition_description"></p>
                </div>
            </div>
            <div class="text-right">
                <p class="text-sm text-gray-500 dark:!text-gray-200">{{ $t('settings.sub_price') }}</p>
                <p class="text-lg font-medium text-gray-800 dark:!text-white">
                    {{ $page.props.user.subscription.plan_price > 0 ? $t('settings.sub_price_monthly', { amount: $page.props.user.subscription.plan_price }) : $t('settings.sub_free') }}
                </p>
            </div>
        </section>

        <section class="bg-white dark:bg-neutral-800 dark:border-neutral-700 border p-6 rounded-lg shadow">
            <h3 class="text-lg font-semibold text-gray-800 dark:!text-white">{{ $t('settings.sub_payment_info') }}</h3>
            <p v-if="$page.props.user.subscription.plan_price > 0" class="text-sm text-gray-600 dark:!text-white mt-2">
                {{ $t('settings.sub_next_payment') }}
                <span class="font-medium text-gray-800">{{ fmtDate($page.props.user.subscription.expiration_date, { month: 'long', year: 'numeric', day: 'numeric' }) }}</span>
            </p>
            <p v-else class="text-sm text-gray-600 dark:!text-gray-200 mt-2">
                {{ $t('settings.sub_plan_free') }}
            </p>
            <p v-if="$page.props.user.subscription.canceled_at" class="text-sm text-gray-600 dark:!text-white mt-2">
                {{ $t('settings.sub_canceled') }}
                <span class="font-medium text-gray-800">{{ fmtDate($page.props.user.subscription.canceled_at, { month: 'long', year: 'numeric', day: 'numeric' }) }}</span>
            </p>
        </section>

        <section class="text-center">
            <p class="text-sm text-gray-600 dark:!text-gray-200 mb-4">
                {{ $t('settings.sub_manage_hint') }}
            </p>
            <a href="/subscriptions" target="_blank">
                <Button severity="contrast" :label="$t('settings.sub_manage_btn')"
                        class="px-8 py-3 text-sm rounded-full shadow-md hover:shadow-lg">
                    <template #icon>
                        <div class="flex items-center flex-col justify-center">
                            <div class="maeum-short"></div>
                            <div class="maeum-long"></div>
                            <div class="maeum-short"></div>
                        </div>
                    </template>
                </Button>
            </a>
        </section>
    </div>
    <div v-else class="p-6">
        {{ $t('settings.sub_unavailable') }}
    </div>
</template>

<style scoped lang="scss">
.bg-gradient-to-b {
    background: linear-gradient(to bottom, #f9fafb, #f3f4f6);
}

.text-gray-800 {
    color: #1f2937;
}

.text-gray-600 {
    color: #4b5563;
}

.text-gray-500 {
    color: #6b7280;
}

.shadow-sm {
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.shadow-md {
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.shadow-lg {
    box-shadow: 0 10px 15px rgba(0, 0, 0, 0.1);
}

.rounded-lg {
    border-radius: 0.75rem;
}

.rounded-xl {
    border-radius: 1rem;
}
</style>
